import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const HeaderContact = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (min-width: ${getBreakpoint('sm')}) {
    flex-direction: row;
    align-items: center;
  }

  a {
    display: flex;
    align-items: center;

    color: ${getColor('white')};
    font-size: 1.4rem;
    font-weight: ${getFontWeight('medium')};
    text-decoration: none;

    &:hover {
      color: ${getColor('accentGreen')};
    }

    @media (min-width: ${getBreakpoint('md')}) {
      font-size: 1.6rem;
    }

    /** svg fill styles for path, polygon are inherited from HeaderContent, including hover styles */
    svg {
      display: none;

      @media (min-width: ${getBreakpoint('sm')}) {
        display: block;

        margin: 0 10px;

        width: 20px;
      }
    }
  }
`;

export default HeaderContact;
